import { defineMessages } from 'react-intl';

export default defineMessages({
  hairColor: {
    id: 'cboard.components.HairColor.hairColor',
    defaultMessage: 'Hair Color'
  },
  hairColorDisabled: {
    id: 'cboard.components.HairColor.hairColorDisabled',
    defaultMessage: 'Hair color options are only available for ARASAAC symbols'
  },
  clearSelection: {
    id: 'cboard.components.HairColor.clearSelection',
    defaultMessage: 'Clear selection'
  }
});
